import { render, staticRenderFns } from "./MailBaserFormCanvas.vue?vue&type=template&id=9f5281d4&scoped=true"
import script from "./MailBaserFormCanvas.vue?vue&type=script&lang=js"
export * from "./MailBaserFormCanvas.vue?vue&type=script&lang=js"
import style0 from "./MailBaserFormCanvas.vue?vue&type=style&index=0&id=9f5281d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5281d4",
  null
  
)

export default component.exports